import React, { FC } from 'react'
import { Col, Row } from 'antd'
import { PhoneInput, FirstNameInput, LastNameInput, MiddleNameInput, Indent } from 'LibNeo'
import { FieldNames } from 'Src/constants/FieldNames'
import { WrappedFormUtils } from 'antd/lib/form/Form'
import { BgTextInput } from 'Pages/ibro'
import { Validators } from 'Modules'

interface ComponentProps {
	form: WrappedFormUtils
	disableAll: boolean
}

export const AgreementForm: FC<ComponentProps> = ({ form, disableAll }) => {
	return (
		<>
			<Row gutter={16} type="flex">
				<Col span={8}>
					<LastNameInput form={form} required disabled={disableAll} />
				</Col>
				<Col span={8}>
					<FirstNameInput form={form} required disabled={disableAll} />
				</Col>
				<Col span={8}>
					<MiddleNameInput form={form} disabled={disableAll} label="Отчество (если есть)" />
				</Col>
			</Row>
			<Indent top={16}>
				<Row gutter={16} type="flex">
					<Col span={8}>
						<PhoneInput
							form={form}
							fieldName={FieldNames.PHONE}
							label="broker.phone"
							disabled={disableAll}
						/>
					</Col>
					<Col span={16}>
						<BgTextInput
							form={form}
							disabled={disableAll}
							fieldName={FieldNames.EMAIL}
							fieldOptions={{
								rules: [
									{
										validator: Validators.checkEmail(),
									},
								],
							}}
							dataQa="email-input"
							label="lib.email"
							placeholder="lib.email_placeholder"
						/>
					</Col>
				</Row>
			</Indent>
		</>
	)
}
